import { getStyles as e } from "./style.js";
import { cn as t } from "../../cn.js";
import { FormErrorText as n, FormHelperText as r, FormLabel as i } from "../shared/form-primitives.js";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Field as s } from "@ark-ui/react/field";
import { Switch as c } from "@ark-ui/react/switch";
// src/design/forms/switch/index.tsx
var l = ({ label: c, helperText: l, errorText: p, required: h, config: g, className: _, disabled: v, size: y, ...b }) => {
	let x = {
		...g,
		size: y ?? g?.size ?? "sm"
	}, S = e(x), C = !!p;
	return /* @__PURE__ */ o(s.Root, {
		className: "flex flex-col gap-1",
		invalid: C,
		required: h,
		disabled: v,
		children: [
			/* @__PURE__ */ o(u, {
				className: t(S.root({ disabled: v }), _),
				disabled: v,
				...b,
				children: [
					/* @__PURE__ */ a(d, {
						config: x,
						className: S.control(),
						children: /* @__PURE__ */ a(f, {
							config: x,
							className: S.thumb()
						})
					}),
					c && /* @__PURE__ */ a(i, {
						required: h,
						disabled: v,
						children: c
					}),
					/* @__PURE__ */ a(m, {})
				]
			}),
			l && !p && /* @__PURE__ */ a(r, { children: l }),
			p && /* @__PURE__ */ a(n, { children: p })
		]
	});
}, u = ({ children: n, className: r, ...i }) => {
	let o = e();
	return /* @__PURE__ */ a(c.Root, {
		className: t(o.root({ disabled: i.disabled }), r),
		...i,
		children: n
	});
}, d = ({ children: n, className: r, config: i, ...o }) => {
	let s = e(i);
	return /* @__PURE__ */ a(c.Control, {
		className: t(s.control(), r),
		...o,
		children: n
	});
}, f = ({ className: n, config: r, ...i }) => {
	let o = e(r);
	return /* @__PURE__ */ a(c.Thumb, {
		className: t(o.thumb(), n),
		...i
	});
}, p = ({ children: n, className: r, ...i }) => {
	let o = e();
	return /* @__PURE__ */ a(c.Label, {
		className: t(o.label(), r),
		...i,
		children: n
	});
}, m = c.HiddenInput, h = Object.assign(l, {
	Default: l,
	Root: u,
	Control: d,
	Thumb: f,
	Label: p,
	HiddenInput: m,
	HelperText: ({ children: e, ...t }) => /* @__PURE__ */ a(r, {
		...t,
		children: e
	}),
	ErrorText: ({ children: e, ...t }) => /* @__PURE__ */ a(n, {
		...t,
		children: e
	}),
	getStyles: e
});
export { h as InputSwitch };

//# sourceMappingURL=index.js.map